import authHeader from './auth-header';
import axios from "../Axios";

export default {

  async login(user) {
    var response = await axios.post(`/auth/login`, {
      email: user.email,
      password: user.password,
    },);
    
    if (response.data && response.data.data) {
      const userData = response.data.data;
      if (userData.token) {
        localStorage.setItem('user_free', JSON.stringify(userData.token));
      }
      return userData;
    }
  },

  // async logout() {
  //   await axios.post(`/auth/logout`, {}, { headers: authHeader() })
  //   localStorage.removeItem('user_free');
  // },
  async logout() {
    const token = JSON.parse(localStorage.getItem('user_free'));
    if (token) {
      try {
        await axios.post(`/auth/logout`, {}, { headers: authHeader() });
      } catch (error) {
        if (error.response && error.response.status === 401) {
          // Token is expired or invalid, proceed to clear local storage
          console.log("Token is expired or invalid, clearing local storage...");
        } else {
          throw error;
        }
      }
    }
    localStorage.removeItem('user_free');
  },
}

